export default {
    methods: {
        filterCollection: function(searchItem) {

            let item = this.orderlines.filter(function(value, key, array) {
                if (value.id == searchItem.id) {
                    return value;
                }
            }, searchItem)[0];

            return item;
        },
        removeOrderLine: function(order) {
            let key = 0;
            for (let i = 0; i < this.orderlines.length; i++) {
                if (this.orderlines[i] === order) {
                    key = i;
                }
            }

            this.orderlines.splice(key, 1);
        },
        unsetAndPushItem: function(item) {
            let key = 0;
            for (let i = 0; i < this.orderlines.length; i++) {
                if (this.orderlines[i] === item) {
                    key = i;
                }
            }

            this.orderlines.push(this.orderlines.splice(key, 1)[0]);
        },
        changeOrderLine(item) {
            switch (item.order_offer) {
                case 0:
                    let offer = this.filterCollection(item);
                    offer.order_offer = 1;
                    this.unsetAndPushItem(offer);
                    break;
                case 1:
                    let order = this.filterCollection(item);
                    order.order_offer = 0;
                    this.unsetAndPushItem(order);
                    break;
            }
        },
        submitOrder() {
            let _this = this;
            WinkelwagenEventBus.$emit("disable-radios");
            axios.post('/winkelwagen/afronden', {
                    "refnr": this.refnr,
                    "note": this.note
                })
                .then(function(response) {
                    if (response.data.redirect) {
                        window.location = response.data.redirect;
                    }
                }, _this).catch(function(error) {
                    _this.$awn.alert("Oeps, daar ging iets mis, probeert u het later nog eens");
                    WinkelwagenEventBus.$emit("enable-radios");
                }, _this);
        },
    },
    computed: {
        orderproducts: function() {
            return this.orderlines.filter(function(value, key, collection) {
                if (value.order_offer === 1) {
                    return value;
                }
            })
        },
        offerproducts: function() {
            return this.orderlines.filter(function(value, key, collection) {
                if (value.order_offer === 0) {
                    return value;
                }
            })
        },
        totalPrice: function() {
            let price = 0;

            for (let i = 0; i < this.orderlines.length; i++) {
                if (this.orderlines[i].order_offer == 1 || this.orderlines[i].residual_product_id) {
                    price += parseFloat(this.orderlines[i].price_per_piece) * this.orderlines[i].pieces;
                }
            }

            // if(this.discountPercentage > 0)
            //     price = price * (1 - (this.discountPercentage / 100));

            return price.toFixed(2);
        },
        totalDiscountedPrice: function() {
            let price = 0;

            for (let i = 0; i < this.orderlines.length; i++) {
                if (this.orderlines[i].order_offer == 1 || this.orderlines[i].price_per_piece) {
                    if (! this.orderlines[i].residual_product_id) {
                        price += parseFloat(this.orderlines[i].price_per_piece) * this.orderlines[i].pieces;
                    }
                }
            }

            return (price.toFixed(2) / 100 * parseFloat(discountPercentage).toFixed(0)).toFixed(2);
        },
        finishAvailable: function() {
            if (this.refnr != "") {
                return this.posting;
            }

            return true
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/cart/helpers/cart/customer.js